import Box from "@mui/material/Box";
import { memo } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Device } from "../../../../../../API";
import LiveViewTimelapseControls from "./LiveViewTimelapseControls";
import LiveViewTimelapseViewer from "./LiveViewTimelapseViewer";
import { useLiveViewTimelapseState } from "./useLiveViewTimelapseState";

type LiveViewTimelapseTabProps = {
  device: Device;
};

const LiveViewTimelapseTab = ({
  device,
}: LiveViewTimelapseTabProps): JSX.Element => {
  const {
    selectedDate,
    minSelectableDate,
    maxSelectableDate,
    timelapseHlsUrl,
    statusMessage,
    loading,
    downloading,
    isDownloadDisabled,
    isDateSelectable,
    handleDateChange,
    handleDownloadClick,
  } = useLiveViewTimelapseState(device);

  return (
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
          border: theme => `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: 0,
          paddingTop: 0,
        }}
      >
        <LiveViewTimelapseViewer
          device={device}
          hlsUrl={timelapseHlsUrl}
          statusMessage={statusMessage}
          loading={loading}
        />

        <LiveViewTimelapseControls
          selectedDate={selectedDate}
          minDate={minSelectableDate}
          maxDate={maxSelectableDate}
          isDownloadDisabled={isDownloadDisabled}
          downloading={downloading}
          isDateSelectable={isDateSelectable}
          onDateChange={handleDateChange}
          onDownload={handleDownloadClick}
        />
      </Box>
    </Box>
  );
};

export default memo(LiveViewTimelapseTab);
